<template>
  <div>
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="24">
        <el-col :span="6">
          <el-input placeholder="请输入姓名或手机号" v-model="queryInfo.cdit" clearable @clear="queryAdminerList"></el-input>
        </el-col>
        <el-col :span="3">
          <el-button icon="el-icon-search" type="success" @click="queryAdminerList">搜索</el-button>
        </el-col>
        <el-col :span="3">
          <el-button type="primary" icon="el-icon-plus" @click="addAdmin">新增</el-button>
        </el-col>
        <el-col :span="6">
          <el-radio-group v-model="queryInfo.status" @change="queryAdminerList">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button :label="1">正常</el-radio-button>
            <el-radio-button :label="0">删除</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>
      <small style="color:#F56C6C;">注：删除管理账号同时删除所在部门分组，且删除后无法恢复！</small>

      <!-- 用户列表区域 -->
      <el-table :data="tableData" stripe>
        <el-table-column type="index" label="序号" min-width="80"></el-table-column>
        <el-table-column label="姓名" prop="name" min-width="80"></el-table-column>
        <el-table-column label="手机号" prop="phoneno" min-width="100"></el-table-column>
        <el-table-column label="是否超管" min-width="80">
          <template slot-scope="scope">
            <span :style="scope.row.is_super === '否'?'color:#EB5753':'color:#6FC334'">{{scope.row.is_super}}</span>
          </template>
        </el-table-column>
        <el-table-column label="最近登陆时间" min-width="100">
          <template slot-scope="scope">
            {{scope.row.last_signin_dt | formatDate}}
          </template>
        </el-table-column>
        <el-table-column label="用户组" min-width="200">
          <template slot-scope="scope">
            <span v-for="(item,ix) in scope.row.groups" :key="ix" style="margin-right:10px;" :style="{'color':ix%2?'#909399':''}">
              {{item.title}}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80">
          <template slot-scope="scope">
            <span :style="scope.row.status == '正常'?'color:#6FC334':'color:#EB5753'">{{scope.row.status}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="275" align="center">
          <template slot-scope="scope">
            <el-button-group>
              <el-button size="medium" type="warning" :disabled="scope.row.status == '删除' ? true :false" @click="showEditDialog(scope.row)">修改</el-button>
              <el-button size="medium" type="success" v-if="scope.row.status == '删除'" @click="statusAdminerById(scope.row.id,1)">恢复</el-button>
              <el-button size="medium" type="danger" v-else @click="statusAdminerById(scope.row.id,0)">删除</el-button>
            </el-button-group>
            <el-button-group style="margin-left:10px;">
              <el-button size="medium" @click="adminerGroups(scope.row.id,scope.row.groups)">部门分组</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <div style="text-align: right">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.page_size" :page-size="queryInfo.page_size" layout="prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </el-card>

    <!-- 添加用户的对话框 -->
    <el-dialog :title="formTitle" :visible.sync="dialogFormVisible" width="50%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="adminerForm" :rules="adminerFormRules" ref="adminerForm" label-width="100px">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="adminerForm.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phoneno">
          <el-input v-model="adminerForm.phoneno"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="adminerForm.password"></el-input>
          <div style="color:#F56C6C;"><small>注：密码留空则表示不修改密码。</small></div>
        </el-form-item>
        <el-form-item label="是否超管">
          <el-radio-group v-model="adminerForm.is_super">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('adminerForm',add_edit)">保存设置</el-button>
      </span>
    </el-dialog>

    <el-dialog title="管理部门分组" :visible.sync="groupsDialogVisible" width="50%">
      <el-form ref="adminerForm1" label-width="100px">
        <el-checkbox-group v-model="groups_id_checked">
          <el-checkbox v-for="item in groups" :key="item.id" :label="item.id">{{item.title}}</el-checkbox>
        </el-checkbox-group>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('adminerForm1')">保存设置</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {
  hex,
  hex_hmac
} from '@/utils/hex.js'

export default {
  data() {
    // 验证手机号的规则
    var checkMobile = (rule, value, cb) => {
      // 验证手机号的正则表达式
      const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/

      if (regMobile.test(value)) {
        return cb()
      }

      cb(new Error('请输入合法的手机号'))
    }

    return {
      type: '',
      formTitle: '',
      add_edit: '',
      // 获取用户列表的参数对象
      queryInfo: {
        status: 1,
        cdit: '',
        page_ix: 1,
        page_size: 10
      },
      tableData: [],
      total: 0,
      dialogFormVisible: false,
      adminerForm: {
        name: '',
        phoneno: '',
        password: '',
        is_super: ''
      },
      adminerFormRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          {
            min: 2,
            max: 20,
            message: '用户名的长度在2~20个字符之间',
            trigger: 'blur'
          }
        ],
        phoneno: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' }
        ]
      },
      groupsDialogVisible: false,
      groups_adminer_id: 0,
      groups: [],
      groups_id_checked: []
    }
  },
  created() {
    this.getGroupList()
    this.queryAdminerList()
  },
  methods: {
    async getGroupList() {
      this.$axios.post('/admin/Auth/getGroups', {}).then(res => {
        if (res.data.rst == 0) {
          this.groups = res.data.data
        }
      })
    },
    async queryAdminerList() {
      this.$axios.post('/admin/Auth/queryAdminer', this.queryInfo).then(res => {
        if (res.data.rst == 0) {
          this.tableData = res.data.data.data
          this.total = res.data.data.total
          this.tableData.forEach(e => {
            e.is_super = !e.is_super ? '否' : '是'
            e.status = !e.status ? '删除' : '正常'
          })
        } else {
          this.alertError(res.data.msg)
        }
      })
    },
    // 监听 page_size 改变的事件
    handleSizeChange(newSize) {
      // console.log(newSize)
      this.queryInfo.page_size = newSize
      this.queryAdminerList()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      // console.log(newPage)
      this.queryInfo.page_size = newPage
      this.queryAdminerList()
    },
    // 监听用户对话框的关闭事件
    addDialogClosed() {
      this.$refs.adminerForm.resetFields()
    },
    addDialogClosed1() {
      this.$refs.adminerForm1.resetFields()
    },
    addAdmin() {
      this.formTitle = '新增管理员信息'
      this.add_edit = 'add'
      this.dialogFormVisible = true
      this.adminerForm = {
        name: '',
        phoneno: '',
        password: '',
        is_super: ''
      }
    },
    adminerGroups(adminer_id, groups) {
      this.groups_adminer_id = adminer_id
      this.groupsDialogVisible = true
      this.groups_id_checked = groups.map(item => {
        return item.id
      })
    },
    // 展示编辑用户的对话框
    showEditDialog(row) {
      this.formTitle = '修改管理员信息'
      this.add_edit = 'edit'
      this.dialogFormVisible = true
      Object.assign(this.adminerForm, row)
      this.adminerForm.is_super = row.is_super == '是' ? 1 : 0
      this.adminerForm.password = ''
    },
    // 提交表单
    submitForm(formName, type) {
      if (formName == 'adminerForm') {
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.add_edit == 'edit' || this.add_edit == 'add') {
              let editparams = {
                name: this.adminerForm.name,
                phoneno: this.adminerForm.phoneno,
                is_super: this.adminerForm.is_super
              }
              if (this.adminerForm.password) {
                editparams['password'] = hex_hmac(String(this.adminerForm.phoneno), hex(this.adminerForm.password))
              } else {
                if (this.add_edit == 'add') {
                  editparams['password'] = hex_hmac(String(this.adminerForm.phoneno), hex(this.adminerForm.phoneno))
                }
              }
              if (this.add_edit == 'edit') {
                editparams['adminer_id'] = this.adminerForm.id
              }
              this.$axios.post('/admin/Auth/saveAdminer', editparams).then(res => {
                if (res.data.rst == 0) {
                  this.alertSuccess(res.data.msg)
                  this.queryAdminerList()
                  this.dialogFormVisible = false
                } else {
                  this.alertError(res.data.msg)
                }
              })
            }
          }
        })
      } else if (formName == 'adminerForm1') {
        let editparams = {
          adminer_id: this.groups_adminer_id,
          groups_id: JSON.stringify(this.groups_id_checked)
        }
        this.$axios.post('/admin/Auth/saveAdminer', editparams).then(res => {
          if (res.data.rst == 0) {
            this.alertSuccess(res.data.msg)
            this.queryAdminerList()
            this.groupsDialogVisible = false
          } else {
            this.alertError(res.data.msg)
          }
        })
      } else;
    },
    async statusAdminerById(id, status) {
      const confirmResult = await this.$confirm(
        '此操作将' + (status == 1 ? '恢复' : '删除') + '该管理账号, 是否继续?',
        '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      let editparams = {
        adminer_id: id,
        status: status
      }
      this.$axios.post('/admin/Auth/saveAdminer', editparams).then(res => {
        if (res.data.rst == 0) {
          this.alertSuccess(res.data.msg)
          this.queryAdminerList()
        } else {
          this.alertError(res.data.msg)
        }
      })
    },
    // 成功弹窗
    alertSuccess(msg) {
      this.$message.success({
        showClose: true,
        duration: 1000,
        message: msg,
        type: 'success'
      })
    },
    // 错误消息
    alertError(msg) {
      this.$message.error({
        duration: 1000,
        showClose: true,
        message: msg,
        type: 'error'
      })
    }
  }

}
</script>

<style lang="less" scoped>
  .tip {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #EB5753;
  }
</style>
